export function go(path, isTime) {
  if (isTime) {
    setTimeout(() => {
      this.$router.push(path); // 跳转到指定路由
    }, 1000); // 延时1秒
  } else {
    this.$router.push(path); // 立即跳转到指定路由
  }
}

export function isLogin() {
    const TOKEN = localStorage.getItem('TOKEN');
    if (TOKEN) {
       return true
    }
    else{
        this.$router.push('/login')
        return false
    }
}
export function goback(isTime) {
      if (isTime) {
    setTimeout(() => {
    this.$router.go(-1); // 返回上一页
    }, 1000); // 延时1秒
  } else {
    this.$router.go(-1); // 返回上一页
  }
}
export function checkForEmptyValues(obj, whitelist = []) {
    const emptyKeys = [];
    for (const key in obj) {
        if (!whitelist.includes(key) && !obj[key]) {
            emptyKeys.push(key);
        }
    }
    return emptyKeys;
}
// utils/validator.js

export const validatePasswordMatch = (password, confirmPassword) => {
    return password === confirmPassword;
};

export const validatePassword = (password) => {
    // 密码基本规则示例：至少8个字符，包含至少一个数字、一个大写字母和一个特殊字符
    const passwordRegex = /^.{8,}$/; 
       return passwordRegex.test(password);
    // return password
};
// export const validatePassword = (password) => {
//     // 密码基本规则示例：至少8个字符，包含至少一个数字、一个大写字母和一个特殊字符
//     const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*()_+])(?=.*[a-zA-Z]).{8,}$/;
//     return passwordRegex.test(password);
//     // return password
// };

export const validateEmail = (email) => {
    // 简单的邮箱验证规则示例
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
